'use client'

import { useConsentManager } from '@c15t/nextjs'

/**
 * Consent hook for Google Tag Manager and Google Analytics (GA4).
 *
 * Both GTM and GA fall under the `measurement` consent category.
 * Returns `enabled: true` only after the user grants measurement consent.
 */
export function useGTMConsent() {
  const { has } = useConsentManager()

  return {
    /** Whether GTM / GA may be loaded */
    enabled: has('measurement'),
  }
}
